// src/renderer/components/SentryErrorBoundary.tsx
import React from 'react';
import * as Sentry from '@sentry/react';

class SentryErrorBoundary extends React.Component<{children: React.ReactNode}> {
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.captureException(error);
  }

  render() {
    return this.props.children;
  }
}

export default SentryErrorBoundary;